import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// Langues supportées
const SUPPORTED_LANGUAGES = {
  'ar': { name: 'العربية', flag: '🇸🇦', country: 'Saudi Arabia', currency: 'SAR', domain: 'komby.io', path: '/ar' },
  'ar-AE': { name: 'العربية (الإمارات)', flag: '🇦🇪', country: 'UAE', currency: 'AED', domain: 'komby.io', path: '/ar-AE' },
  'ar-EG': { name: 'العربية (مصر)', flag: '🇪🇬', country: 'Egypt', currency: 'EGP', domain: 'komby.io', path: '/ar-EG' },
  'ar-MA': { name: 'العربية (المغرب)', flag: '🇲🇦', country: 'Morocco', currency: 'MAD', domain: 'komby.io', path: '/ar-MA' },
  'bg': { name: 'Български', flag: '🇧🇬', country: 'Bulgaria', currency: 'BGN', domain: 'komby.io', path: '/bg' },
  'cs': { name: 'Čeština', flag: '🇨🇿', country: 'Czech Republic', currency: 'CZK', domain: 'komby.io', path: '/cs' },
  'da': { name: 'Dansk', flag: '🇩🇰', country: 'Denmark', currency: 'DKK', domain: 'komby.io', path: '/da' },
  'de': { name: 'Deutsch', flag: '🇩🇪', country: 'Germany', currency: 'EUR', domain: 'komby.io', path: '/de' },
  'de-CH': { name: 'Deutsch (Schweiz)', flag: '🇨🇭', country: 'Switzerland', currency: 'CHF', domain: 'komby.io', path: '/de-CH' },
  'el': { name: 'Ελληνικά', flag: '🇬🇷', country: 'Greece', currency: 'EUR', domain: 'komby.io', path: '/el' },
  'en': { name: 'English', flag: '🇬🇧', country: 'United Kingdom', currency: 'GBP', domain: 'komby.io', path: '/en' },
  'en-AU': { name: 'English (Australia)', flag: '🇦🇺', country: 'Australia', currency: 'AUD', domain: 'komby.io', path: '/en-AU' },
  'en-CA': { name: 'English (Canada)', flag: '🇨🇦', country: 'Canada', currency: 'CAD', domain: 'komby.io', path: '/en-CA' },
  'en-NZ': { name: 'English (New Zealand)', flag: '🇳🇿', country: 'New Zealand', currency: 'NZD', domain: 'komby.io', path: '/en-NZ' },
  'en-SG': { name: 'English (Singapore)', flag: '🇸🇬', country: 'Singapore', currency: 'SGD', domain: 'komby.io', path: '/en-SG' },
  'en-US': { name: 'English (United States)', flag: '🇺🇸', country: 'United States', currency: 'USD', domain: 'komby.io', path: '/en-US' },
  'en-ZA': { name: 'English (South Africa)', flag: '🇿🇦', country: 'South Africa', currency: 'ZAR', domain: 'komby.io', path: '/en-ZA' },
  'es': { name: 'Español', flag: '🇪🇸', country: 'Spain', currency: 'EUR', domain: 'komby.io', path: '/es' },
  'es-ES': { name: 'Español (España)', flag: '🇪🇸', country: 'Spain', currency: 'EUR', domain: 'komby.io', path: '/es-ES' },
  'es-MX': { name: 'Español (México)', flag: '🇲🇽', country: 'Mexico', currency: 'MXN', domain: 'komby.io', path: '/es-MX' },
  'et': { name: 'Eesti', flag: '🇪🇪', country: 'Estonia', currency: 'EUR', domain: 'komby.io', path: '/et' },
  // SANCTIONS: temporarily hidden - Iran
  // 'fa': { name: 'فارسی', flag: '🇮🇷', country: 'Iran', currency: 'IRR', domain: 'komby.io', path: '/fa' },
  'fi': { name: 'Suomi', flag: '🇫🇮', country: 'Finland', currency: 'EUR', domain: 'komby.io', path: '/fi' },
  'fr': { name: 'Français', flag: '🇫🇷', country: 'France', currency: 'EUR', domain: 'komby.io', path: '/fr' },
  'fr-CH': { name: 'Français (Suisse)', flag: '🇨🇭', country: 'Switzerland', currency: 'CHF', domain: 'komby.io', path: '/fr-CH' },
  'he': { name: 'עברית', flag: '🇮🇱', country: 'Israel', currency: 'ILS', domain: 'komby.io', path: '/he' },
  'hi': { name: 'हिन्दी', flag: '🇮🇳', country: 'India', currency: 'INR', domain: 'komby.io', path: '/hi' },
  'hr': { name: 'Hrvatski', flag: '🇭🇷', country: 'Croatia', currency: 'EUR', domain: 'komby.io', path: '/hr' },
  'hu': { name: 'Magyar', flag: '🇭🇺', country: 'Hungary', currency: 'HUF', domain: 'komby.io', path: '/hu' },
  'id': { name: 'Bahasa Indonesia', flag: '🇮🇩', country: 'Indonesia', currency: 'IDR', domain: 'komby.io', path: '/id' },
  'it': { name: 'Italiano', flag: '🇮🇹', country: 'Italy', currency: 'EUR', domain: 'komby.io', path: '/it' },
  'it-CH': { name: 'Italiano (Svizzera)', flag: '🇨🇭', country: 'Switzerland', currency: 'CHF', domain: 'komby.io', path: '/it-CH' },
  'ja': { name: '日本語', flag: '🇯🇵', country: 'Japan', currency: 'JPY', domain: 'komby.io', path: '/ja' },
  'ko': { name: '한국어', flag: '🇰🇷', country: 'South Korea', currency: 'KRW', domain: 'komby.io', path: '/ko' },
  'lt': { name: 'Lietuvių', flag: '🇱🇹', country: 'Lithuania', currency: 'EUR', domain: 'komby.io', path: '/lt' },
  'lv': { name: 'Latviešu', flag: '🇱🇻', country: 'Latvia', currency: 'EUR', domain: 'komby.io', path: '/lv' },
  'ms': { name: 'Bahasa Melayu', flag: '🇲🇾', country: 'Malaysia', currency: 'MYR', domain: 'komby.io', path: '/ms' },
  'nl': { name: 'Nederlands', flag: '🇳🇱', country: 'Netherlands', currency: 'EUR', domain: 'komby.io', path: '/nl' },
  'no': { name: 'Norsk', flag: '🇳🇴', country: 'Norway', currency: 'NOK', domain: 'komby.io', path: '/no' },
  'pl': { name: 'Polski', flag: '🇵🇱', country: 'Poland', currency: 'PLN', domain: 'komby.io', path: '/pl' },
  'pt': { name: 'Português', flag: '🇵🇹', country: 'Portugal', currency: 'EUR', domain: 'komby.io', path: '/pt' },
  'pt-BR': { name: 'Português (Brasil)', flag: '🇧🇷', country: 'Brazil', currency: 'BRL', domain: 'komby.io', path: '/pt-BR' },
  'ro': { name: 'Română', flag: '🇷🇴', country: 'Romania', currency: 'RON', domain: 'komby.io', path: '/ro' },
  // SANCTIONS: temporarily hidden - Russia
  // 'ru': { name: 'Русский', flag: '🇷🇺', country: 'Russia', currency: 'RUB', domain: 'komby.io', path: '/ru' },
  'sk': { name: 'Slovenčina', flag: '🇸🇰', country: 'Slovakia', currency: 'EUR', domain: 'komby.io', path: '/sk' },
  'sl': { name: 'Slovenščina', flag: '🇸🇮', country: 'Slovenia', currency: 'EUR', domain: 'komby.io', path: '/sl' },
  'sv': { name: 'Svenska', flag: '🇸🇪', country: 'Sweden', currency: 'SEK', domain: 'komby.io', path: '/sv' },
  'th': { name: 'ไทย', flag: '🇹🇭', country: 'Thailand', currency: 'THB', domain: 'komby.io', path: '/th' },
  'tr': { name: 'Türkçe', flag: '🇹🇷', country: 'Turkey', currency: 'TRY', domain: 'komby.io', path: '/tr' },
  'uk': { name: 'Українська', flag: '🇺🇦', country: 'Ukraine', currency: 'UAH', domain: 'komby.io', path: '/uk' },
  'vi': { name: 'Tiếng Việt', flag: '🇻🇳', country: 'Vietnam', currency: 'VND', domain: 'komby.io', path: '/vi' },
  'zh': { name: '中文', flag: '🇨🇳', country: 'China', currency: 'CNY', domain: 'komby.io', path: '/zh' }
};

export type SupportedLanguageCode = keyof typeof SUPPORTED_LANGUAGES;

/**
 * Canonicalise un code langue (ex. fr-ch → fr-CH) pour matcher SUPPORTED_LANGUAGES.
 * Sans ça, l'URL Netlify en minuscules casse le mapping langue → devise (fallback GBP).
 */
export function resolveSupportedLanguage(
  code: string | undefined | null
): SupportedLanguageCode | null {
  if (!code) return null;
  if (SUPPORTED_LANGUAGES[code as SupportedLanguageCode]) {
    return code as SupportedLanguageCode;
  }
  const lower = code.toLowerCase();
  for (const key of Object.keys(SUPPORTED_LANGUAGES) as SupportedLanguageCode[]) {
    if (key.toLowerCase() === lower) return key;
  }
  const base = lower.split('-')[0];
  if (SUPPORTED_LANGUAGES[base as SupportedLanguageCode]) {
    return base as SupportedLanguageCode;
  }
  return null;
}

// Détection de langue depuis l'URL - EXÉCUTION IMMÉDIATE
const detectLanguageFromPath = () => {
  if (typeof window === 'undefined') return 'en';
  
  const path = window.location.pathname;
  const langMatch = path.match(/^\/([a-zA-Z]{2}(?:-[a-zA-Z]{2})?)(\/|$)/i);
  
  if (langMatch) {
    const resolved = resolveSupportedLanguage(langMatch[1]);
    if (resolved) return resolved;
  }
  
  return 'en';
};

// 🎯 CRITIQUE : Détecter la langue AVANT d'initialiser i18next
const initialLanguage = detectLanguageFromPath();

// 🚨 CRITIQUE : NETTOYER LE LOCALSTORAGE AVANT INIT
// Le localStorage peut contenir une langue différente de l'URL (ex: 'en')
// Ce qui écrase la détection depuis l'URL
if (typeof window !== 'undefined' && localStorage.getItem('i18nextLng')) {
  const storedLang = localStorage.getItem('i18nextLng');
  if (storedLang !== initialLanguage) {
    localStorage.removeItem('i18nextLng');
  }
}

// 🚀 OPTIMISATION : Charger UNIQUEMENT 'common' au démarrage
// Les autres namespaces sont chargés à la demande par les composants
const INITIAL_NAMESPACES = ['common'];

// Tous les namespaces disponibles (chargés à la demande)
const ALL_NAMESPACES = ['common', 'home', 'pricing', 'contact', 'auth', 'signup', 'success', 'seo', 'currencies', 'comingSoon', 'admin', 'support', 'dashboard', 'compare', 'compare-vs', 'use-case', 'replace-stack', 'sector-vs', 'office', 'resto', 'blog', 'about', 'press', 'team', 'careers', 'legal', 'legalMessages', 'newsletter', 'addressFormats', 'dateTimeFormats', 'phoneFormats', 'test', 'settings', 'music', 'blog-articles'];

// Configuration i18next optimisée pour SSG + hydratation React
i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: initialLanguage, // ✅ FORCÉ : Langue détectée depuis l'URL
    fallbackLng: false, // 🚨 CRITIQUE : NE PAS charger l'anglais en fallback
    debug: false, // Debug désactivé en production
    
    // 🚀 OPTIMISATION : Charger uniquement 'common' au démarrage (17KB vs 200KB)
    ns: INITIAL_NAMESPACES,
    defaultNS: 'common',
    
    // 🚀 OPTIMISATION : Déclarer tous les namespaces disponibles pour le lazy loading
    partialBundledLanguages: true,
    
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // 🚨 CRITIQUE : Charger UNIQUEMENT la langue demandée, pas le fallback
      allowMultiLoading: false
    },
    
    interpolation: {
      escapeValue: false
    },
    
    react: {
      useSuspense: true, // ✅ CRITIQUE : Attendre le chargement des traductions avant de rendre
      bindI18n: 'languageChanged loaded', // Réagir au chargement des namespaces
      bindI18nStore: 'added' // Réagir quand un namespace est ajouté
    },
    
    // 🚨 CRITIQUE : Ne pas charger le fallback tant que la langue principale n'est pas chargée
    load: 'currentOnly', // Ne charge QUE la langue actuelle, pas les fallbacks
    
    // 🚨 NOUVEAU : Désactiver TOUS les fallbacks de namespace
    fallbackNS: false,
    
    // 🚨 NOUVEAU : Retourner la clé si la traduction n'existe pas (au lieu de fallback EN)
    returnEmptyString: false,
    saveMissing: false,
    
    initImmediate: false
  });

// Export pour les composants qui ont besoin de charger des namespaces spécifiques
export { ALL_NAMESPACES };

export default i18n;
export { SUPPORTED_LANGUAGES, detectLanguageFromPath };

/** Préfixe URL canonique pour la langue courante (ex. /fr-CH). */
export function getLanguagePathPrefix(pathname?: string): string {
  const path = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '/en');
  const raw = path.match(/^\/([a-zA-Z]{2}(?:-[a-zA-Z]{2})?)(?:\/|$)/i)?.[1];
  const resolved = resolveSupportedLanguage(raw);
  if (resolved) {
    return SUPPORTED_LANGUAGES[resolved].path || `/${resolved}`;
  }
  return '/en';
}